import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createLocationSuccess } from 'src/app/pages/add-location/state/add-location.actions';
import {
   deleteLocationSuccess,
   saveLocationDetailSuccess,
} from 'src/app/pages/location-details/state/location-detail.actions';
import {
   EagerSelectState,
   createEagerSelectAdapter,
   createEagerSelectReducer,
} from '../../select/eager-select/eager-select-reducer';
import { filterLocationOption } from '../../select/shared/filter-location-option';
import { LocationOption } from '../models/location-option.interface';
import { locationOptionActions } from './location-option.actions';

export const locationOptionFeatureKey = 'locationOptions';

export type LocationOptionState = EagerSelectState<LocationOption>;

const adapter = createEagerSelectAdapter<LocationOptionState, LocationOption>({
   featureKey: locationOptionFeatureKey,
   selectId: (location: LocationOption) => {
      return location.locationId;
   },
});

export const locationOptionSelectors = adapter.getSelectors(filterLocationOption);

const initialState = adapter.getInitialState();

export const locationOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   locationOptionActions.search,
   locationOptionActions.searchReset,
   locationOptionActions.loadFromApi,
   locationOptionActions.loadFromApiSuccess,
   locationOptionActions.loadFromApiFailure,
   null,
   on(createLocationSuccess, saveLocationDetailSuccess, deleteLocationSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);
